(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("icon", [], factory);
	else if(typeof exports === 'object')
		exports["icon"] = factory();
	else
		root["icon"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 